export enum VettingRuleTypes {
  BU = 'B',
  Global = 'G',
}
